import React from "react";
import { Link } from "react-router-dom";
import "./WhyJoinUs.css";

const WhyJoinUs = () => {
  return (
    <div className="why-join-us-page">
      {/* Hero Banner */}
      <section className="why-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1>Why Join Dive-in Panels?</h1>
              <p>
                Because your opinions and our data can innovate products and
                reform brands. You believe, and we trust in innovation.
              </p>
              <p>
                Because our questionnaires and your sentiments make products
                merit or demerit. Your views push brands to innovate and
                improve. And innovations promise reforms. Your thoughts and our
                studies can promote brands to bring these reforms.
              </p>
              <p>
                What else? You fill the surveys to make money for every precious
                minute you spend with us.
              </p>
            </div>
            <div className="col-md-6">
              <figure className="why-image">
                <img src="/assets/images/whyjoin.png" alt="Why join us" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Why Dive-in Section */}
      <section className="why-dive-section">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <h2 className="section-title text-center mb-5">
                Why Dive-in Panels?
              </h2>
              <p className="text-center">
                We don't brand ourselves to be the best online survey site. We
                just go about our work and value your time by aiding you to{" "}
                <Link to="/how-it-works">earn money through surveys</Link>. And
                help market researchers who bring reforms in the market and
                brands.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick and Relevant Surveys */}
      <section className="feature-section bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="feature-title text-center">
                Quick and Relevant Surveys
              </h2>
              <figure className="feature-image">
                <img
                  src="assets/images/join_us_image2.png"
                  alt="Quick and Relevant Surveys"
                />
              </figure>
            </div>
            <div className="col-md-6">
              <p>
                No larking around. We value your time. You want it quick? Our
                surveys are short yet precise to the topic. You can finish basic
                reviews in a jiffy even before your coffee loses its steam.
              </p>
              <p>
                No BS questions. You receive freshly-minted and fascinating
                surveys based on your profile. So, the soccer lover in you won't
                be asked to share views on soap operas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Your Data, Our Duty */}
      <section className="feature-section bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <h2 className="feature-title text-center">Your Data, Our Duty</h2>
              <figure className="feature-image">
                <img
                  src="assets/images/join_us_image3.png"
                  alt="Secured Data"
                />
              </figure>
            </div>
            <div className="col-md-6 order-md-1">
              <p>
                No data breach. Relax and sit back while you answer your
                questions. Your security is sealed and safe. Don't worry about
                receiving more pesky emails or calls.
              </p>
              <p>
                No referrals leak. Your references are locked with us. You
                wouldn't hear them complaining of unsolicited messages. Not from
                our channels!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cancel Anytime */}
      <section className="feature-section bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="feature-title text-center">Cancel Anytime</h2>
              <figure className="feature-image">
                <img src="assets/images/Group_46.png" alt="Cancel Anytime" />
              </figure>
            </div>
            <div className="col-md-6">
              <p>
                No strings attached. Close your account anytime. We understand
                when you get busy. Just drop us a note, and you are set to part.
                However, we would love to keep in touch. We often surprise our
                genuine users.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Showering Rewards */}
      <section className="feature-section bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <h2 className="feature-title text-center">Showering Rewards</h2>
              <figure className="feature-image">
                <img src="assets/images/reward.png" alt="Rewards" />
              </figure>
            </div>
            <div className="col-md-6 order-md-1">
              <p>
                No hollow words. You get instant points on each completed
                survey. Collect rewards even if you fill optional questions.
                Cash in every 1000 points.
              </p>
              <p>
                No painful gains. Refer your friends, family, and colleagues.
                And spike the earnings in your Dive-in Panels account.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Simple yet Scientific Approach */}
      <section className="feature-section bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="feature-title text-center">
                Simple yet Scientific Approach
              </h2>
              <figure className="feature-image">
                <img src="assets/images/sync.png" alt="Scientific Approach" />
              </figure>
            </div>
            <div className="col-md-6">
              <p>
                No vague review system. We compile simple questionnaires based
                on scientific and proven methods. AI and analytics drive our
                technology.
              </p>
              <p>
                No additional analysis needed. Our research partners and brands
                receive lucid survey results. We make interpretation easy for
                them to reform the products and services.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="cta-title">
                Ready to fill and share surveys for money?
              </h2>
              <Link to="/auth/register" className="btn btn-cta">
                Register Me
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyJoinUs;
